import { useQuery } from 'react-query';
import { get } from '../../../lib/api';

export const useGetAwsData = ({ origin }) => {
  const { data = {} } = useQuery(['awsData', origin], async () => {
    const response = await get('/client_admin/aws_settings', {
      origin,
    });
    return response.data;
  });

  return data;
};
